export enum ProjectConfigurationTaskStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  CANCELED = 'CANCELED',
  ERROR = 'ERROR',
}

export interface ConfigurationTask {
  id: number;
  name: string;
  task: string;
  description: string;
  required: boolean;
  scope: string;
  automatic: boolean;
  order: number;
}

export interface ProjectConfigurationTask {
  id: number;
  configuration_task_id: number;
  project_id: number;
  status: ProjectConfigurationTaskStatus;
  notes?: string | null;
  updated_by?: number | null;
  created_at: string;
  updated_at: string;
  configuration_task: ConfigurationTask;
}

/**
 * Known configuration task keys coming from the API. This enum is optional for typing slots
 * and should not be used to narrow the interface type, since the backend may return
 * additional values. Extend as new tasks are introduced.
 */
export enum ConfigurationTaskKey {
  BUSINESS_REGISTRATION = 'business_registration',
  CLEEPO_INTERVIEW = 'cleepo_interview',
  BRIEF_GENERATION = 'brief_generation',
  BRIEF_CONFIRMATION = 'brief_confirmation',
  LANDING_CONTENT_GENERATION = 'landing_content_generation',
  LOGO_UPDATE = 'logo_update',
  LANDING_IMAGES_UPDATE = 'landing_images_update',
  LANDING_PUBLICATION = 'landing_publication',
  DOMAIN_SELECTION = 'domain_selection',
}

// Typed list of known task keys for template-literal types and IDE DX
export const configurationTaskKeyValues = [
  'business_registration',
  'cleepo_interview',
  'brief_generation',
  'brief_confirmation',
  'landing_content_generation',
  'logo_update',
  'landing_images_update',
  'landing_publication',
  'domain_selection',
] as const;

export type ConfigurationTaskKeyValue = (typeof configurationTaskKeyValues)[number];

// Slot name type for components that expose dynamic slots
export type ConfigurationTaskSlotName = `${ConfigurationTaskKeyValue}-content`;
